import React from 'react';
import PropTypes from 'prop-types';
import logo from './logo.png';
import styles from './NavigationBar.scss';

export default function BrandFlag({ brandHref, brandImage, onClick }) {
	return (
		<a className={styles.brandFlag} href={brandHref} onClick={onClick}>
			<span>
				<svg
					preserveAspectRatio="xMinYMin meet"
					version="1.1"
					viewBox="0 0 280 184">
					<path d="M 0,0 L 280,0 280,114 Q 280 124 270 128 L 157,179 C 140 184.5, 140 184.5, 123 179 L 10,128 Q 0 124 0 114 Z" />
				</svg>
				<div className={styles.imageContainer}>
					<img alt="Direct Supply" src={brandImage} />
				</div>
			</span>
		</a>
	);
}
BrandFlag.propTypes = {
	brandHref: PropTypes.string.isRequired,
	brandImage: PropTypes.string,
	onClick: PropTypes.func
};
BrandFlag.defaultProps = {
	brandImage: logo
};
